/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { Component, ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import { ConnectedProps, connect } from 'react-redux';
import uuid from 'uuid';
import SearchUtils from '../../../utils/SearchUtils';
import { setFilteredSearchDropdownItems } from '../../../actions/searchActions';
import SearchDropdownHistoryItem from './SearchDropdownHistoryItem';
import SearchAnalytics from '../../../analytics/SearchAnalytics';
type OwnProps = {
	searchHostContext: HostContext;
	logger: Logger;
	onSubmit: (...args: Array<any>) => any;
	searchQuery: string;
	hostShowSearchDropdown: boolean;
};

type SearchDropdownHistoryProps = OwnProps & PropsFromRedux;
/*
 * SearchHistory for Search.
 */
class SearchHistory extends Component<SearchDropdownHistoryProps> {
	/**
	 * Returns the render for the Search History Items
	 * @returns <element>
	 */

	renderHistoryTitle() {
		const historyTitleId = 'app.search.presearch.history.title';
		if (this.props.searchQuery) {
			return null;
		}
		return (
			<h5 className='search-dropdown-history-title'>
				<FormattedMessage id={historyTitleId} />
			</h5>
		);
	}
	renderHistoryItems(historyItems) {
		let elements: ReactElement[] = [];
		// Return only the top 6 items
		const list = historyItems.slice(0, 6);
		SearchAnalytics.dropDownData.searchHistory = list;

		// Show the Search History Dropdown with the list of search history items
		const analytics = new SearchAnalytics(this.props.searchHostContext);
		analytics.postSuggestionRender(list, 'suggestion', 'history');
		elements = list.map((item, index) => (
			<SearchDropdownHistoryItem
				key={uuid.v4()}
				item={item}
				index={index}
				searchQuery={this.props.searchQuery}
				hostShowSearchDropdown={this.props.hostShowSearchDropdown}
				onSubmit={this.props.onSubmit}
				logger={this.props.logger}
				searchHostContext={this.props.searchHostContext}
			/>
		));
		return elements.length ? elements : null;
	}

	render() {
		const historyItems = SearchUtils.getFilteredSearchHistoryItems(
			this.props.searchQuery,
			this.props.searchHistoryItems,
		);

		if (historyItems && Array.isArray(historyItems) && historyItems.length > 0) {
			return (
				<div className='search-dropdown-history-container'>
					{this.renderHistoryTitle()}
					{this.renderHistoryItems(historyItems)}
				</div>
			);
		}
		return null;
	}
}

const mapStateToProps = ({ search }: RootState) => ({
	searchHistoryItems: search.searchHistoryItems,
});

const mapDispatchToProps = {
	setFilteredSearchDropdownItems,
};
const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(SearchHistory);
